/**
 * Created: 2020-07-01
 * @author Jie Gao
 */

import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {PickButton} from "./PickButton";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {WinterHoardParsedGameData, WinterHoardParsedInitData} from "../../server/data/IWinterHoardServerData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../../config/WinterHoardLayerConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {WinterHoardSoundConfig} from "../../WinterHoardSoundConfig";
import {SoundPlayer} from "../../sound/SoundPlayer";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";


export class BuffaloFreeSpinIntroView extends BaseView {

    private readonly _buttonNames: string[] = ["Transform", "Multiplier"];
    private readonly _buttonIldeNames: string[] = ["horde_mouseover", "prairie_mouseover"];
    private readonly _buttonMouseOutNames: string[] = ["horde_mouseout", "prairie_mouseout"];
    private readonly _superButtonName: string = "Super";
    private readonly _featureTextStrings: string[] = ["SYMBOL TRANSFORM", "SYMBOL MULTIPLIERS"];
    private readonly _buttonPosY: number = -40;
    private _isSuper: boolean = false;

    private readonly _featureTextStyle: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontSize: 30,
        fill: 0xffffff,
        // fontStyle : FontStyle.ITALIC,
        fontWeight: FontWeight.BOLD,
        wordWrap: false
    };
    private readonly _volatilityTextStyle: any = {
        fill: 0xffffff,
        fontFamily: "Open Sans",
        wordWrap: false,
        fontWeight: FontWeight.BOLD,
        fontSize: 22
    };
    private _featureTextMinScale: number = 1;
    private _volatilityBar: PIXI.Container;
    private _highVLogo: PIXI.Sprite;
    private _extremeVLogo: PIXI.Sprite;
    private _buttons: PickButton[];
    private _numberFreespins: number[];
    private _featureTexts: PIXI.Text[];
    ///////////////////////////////////////
    private _superButton: PickButton;
    private _freespinsLeft: number;

    private _completeCallback?: () => void;
    private _dimmer: PIXI.Sprite;
    private _container: PIXI.Container;
    private _layer: PIXI.Container;
    private _replayPlayerSelectionIndex: number = -1;
    private _bdata:ParsedServerData;
    public _isWaiting:boolean = false;
    private endTl:TimelineLite | null;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_INTRO.name);
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onPickAndClickClosed(event.params[0]));
    }

    protected initAnimations(): void {
        this._container = new PIXI.Container();
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.position.set(0, 0);
        this._dimmer.tint = 0X000000;
        this._dimmer.alpha = 0;
        this._container.addChild(this._dimmer);
        this._featureTexts = [];
        this._buttons = this.createButtons();

        this._superButton = new PickButton(this._superButtonName, "sb_mouseover","sb_mouseout",
            () => {
                this.continueButtonClicked();
            });
        this._superButton.createAnimation();
        this._superButton.scale.set(0.9);
        this._superButton.position.set(-8, 5);
        this._volatilityBar = this.createVolatilityBar();

        this._container.addChild(this._buttons[0], this._buttons[1], this._superButton, this._volatilityBar);

        this._container.position.set(360, 360);
        this.addChild(this._container);

    }

    private createButtons(): PickButton[] {
        let buttons: PickButton[] = [];
        this._buttonNames.forEach((name: string, i: number) => {
            const button: PickButton = this.createButton(i);
            button.createAnimation();
            button.enabled = false;
            button.position.set(0, this._buttonPosY);
            buttons.push(button);
        });

        return buttons;
    };

    private createButton(index: number): PickButton {
        const keyword: string = this._buttonNames[index];
        const button: PickButton = new PickButton(keyword, this._buttonIldeNames[index],this._buttonMouseOutNames[index],
            () => {
                button.enabled = false;
                this.disableButtons(index);
                new TimelineLite().add(()=>{
                    SlotGame.api.betHandler.pickAndClickBet(index+1,false);
                },1);
            });

        const featureText: PIXI.Text = new PIXI.Text(Translation.translate(this._featureTextStrings[index]), this._featureTextStyle);
        featureText.anchor.set(0.5);
        Helper.shrinkTextWidth(Translation.translate(this._featureTextStrings[index]), featureText, 330);
        featureText.alpha = 0;

        this._container.addChild(featureText);
        this._featureTexts.push(featureText);
        if (featureText.width > 330) {
            this._featureTextMinScale = Math.min(this._featureTextMinScale, MathHelper.roundToDecimals(330 / featureText.width, 2));
        }
        return button;
    }

    private createVolatilityBar(): PIXI.Container {
        const container: PIXI.Container = new PIXI.Container();
        this._highVLogo = new PIXI.Sprite(GameResources.getTextures("volatilityHigh")[0]);
        this._highVLogo.anchor.set(0.5);
        this._extremeVLogo = new PIXI.Sprite(GameResources.getTextures("volatilityExtreme")[0]);
        this._extremeVLogo.anchor.set(0.5);

        const bar: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bar")[0]);
        bar.anchor.set(0.5);
        container.addChild(bar);

        let textMinScale: number = 1;
        const text1: PIXI.Text = new PIXI.Text(Translation.translate("High risk, high potential"), this._volatilityTextStyle);
        text1.anchor.set(1, 1);
        text1.position.set(320, -12);
        container.addChild(text1);
        if (text1.width > 300) {
            textMinScale = Math.min(textMinScale, MathHelper.roundToDecimals(300 / text1.width, 2));
        }

        const text2: PIXI.Text = new PIXI.Text(Translation.translate("Win more often"), this._volatilityTextStyle);
        text2.anchor.set(0, 1);
        text2.position.set(-290, -12);
        container.addChild(text2);
        if (text2.width > 300) {
            textMinScale = Math.min(textMinScale, MathHelper.roundToDecimals(300 / text2.width, 2));
        }

        if (textMinScale < 1) {
            text1.scale.set(textMinScale);
            text2.scale.set(textMinScale);
        }

        container.addChild(this._highVLogo);
        container.addChild(this._extremeVLogo);
        return container;
    }

    private showButtons(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._buttons.forEach((button: PickButton, i: number) => {
            tl.add(TweenLite.fromTo(this._featureTexts[i], 0.2, {alpha: 0}, {alpha: 1}));
            tl.add(() => {
                button.enabled = true;
                button.setFSNumber(this._numberFreespins[i], true);
            });
        });
        return tl;
    }

    private playReplay(): TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            //debugger;
            if(this._bdata.nextMode === "FREESPIN_PICK" ||this._bdata.nextMode === "FREESPIN_PICK") {
                //console.log("MODE: " + this._toMode);
                WinterHoardGameModuleConfig.indicatorBackground.activateEnteringFS();
                /*if(this._bdata.nextMode === "FREESPIN_TRANSFORM") {
                    WinterHoardGameModuleConfig.freeSpinCounterView.show();
                }
                else if(this._bdata.nextMode === "FREESPIN_MULTIPLIER") {
                    WinterHoardGameModuleConfig.freeSpinMultiplierView.show();
                }*/
            }
        });

        tl.add(() => {
            this._buttons[this._replayPlayerSelectionIndex - 1].playMouseDownGlow();
            if(this._replayPlayerSelectionIndex - 1 === 0) {
                //this._buttons[1].setState(ButtonState.disabled);
                this._buttons[1].interactiveEnabled = false;
            }
            else if(this._replayPlayerSelectionIndex - 1 === 1) {
                //this._buttons[0].setState(ButtonState.disabled);
                this._buttons[0].interactiveEnabled = false;
            }
        });
        tl.add(() => {
            this._buttons[this._replayPlayerSelectionIndex - 1].click(true);
        }, 0.95);

        return tl;
    }

    private playSuperModeReplay(): TimelineLite {
        return new TimelineLite().add(() => {
            WinterHoardGameModuleConfig.indicatorBackground.activateEnteringFS();
            this._superButton.click();
        }, 1);
    }

    private hideButtons(): void {
        this._buttons.forEach((button: PickButton) => {
            button.enabled = false;
            button.reset();
        });
        this._superButton.enabled = false;
        this._superButton.reset();
    }

    private disableButtons(i:number): void{
        this._buttons[(i+1)%2].showDisable();
    }

    private continueButtonClicked = () => {
        this.hideButtons();
        if (this._completeCallback) {
            this._completeCallback();
        }

        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    };

    public showPickScreen(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        this._isWaiting = false;
        this._volatilityBar.alpha = 0;
        this._completeCallback = completeCallback;
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._isWaiting = true;
                this._dimmer.alpha = 0;
                this.hideButtons();
                this.alpha = 1;
                this._layer.addChild(this);
            }
        });

        tl.add([
            ()=>SoundPlayer.playEffect(WinterHoardSoundConfig.FREESPIN_START),
            new TweenLite(this._dimmer, 0.2, {alpha: 0.6}),
            new TweenLite(this._volatilityBar, 0.2, {alpha: 1}),
        ], "+=0.5");
        tl.add(() => {
            this._buttons[0].show("intro_horde");
        });
        tl.add(() => {
            this._buttons[1].show("intro_prairie");
        }, "+=0.5");
        tl.add(this.showButtons(), "+=0.5");
        tl.add(() => prepareToEnterModeCallback());
        if (GameSetting.replayMode) {
            tl.add(this.playReplay());
            //tl.add(() => {}, "+=1.0")
        }
        return tl;
    }

    public showSuperBonus(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        this._isWaiting = false;
        this._isSuper = true;
        this._completeCallback = completeCallback;
        const button: PickButton = this._superButton;
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._isWaiting = true;
                this._dimmer.alpha = 0;
                this._volatilityBar.alpha = 0;
                this.hideButtons();
                this.alpha = 1;
                this._layer.addChild(this);
            }
        });

        tl.add([
            ()=>SoundPlayer.playEffect(WinterHoardSoundConfig.FREESPIN_START),
            new TweenLite(this._dimmer, 0.2, {alpha: 0.6})
        ], "+=0.5");
        tl.add(() => {
            this._superButton.show("intro_sb");
        });
        tl.add(() => {
            button.enabled = true;
            button.setFSNumber(this._freespinsLeft, true, true);
        }, "+=2");
        tl.add(() => prepareToEnterModeCallback());
        if (GameSetting.replayMode) {
            tl.add(this.playSuperModeReplay());
        }
        return tl;
    }

    public getEndAnimation(data: WinterHoardParsedGameData): TimelineLite {
        const bdata: any = <ParsedServerData>data;
        this._bdata = bdata;
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                this._superButton.enabled = false;
                this._buttons[0].enabled = false;
                this._buttons[1].enabled = false;
                WinterHoardGameModuleConfig.reelBackground.switchBg("fs");
                WinterHoardGameModuleConfig.indicatorBackground.activateEnteringFS()

                if (this._numberFreespins && this._numberFreespins.length > 1 && this._numberFreespins[0] && this._numberFreespins[0] > 0) {
                    SlotGame.keypad.setZeroBetSpinCounter(this._numberFreespins[0]);
                }
                else if(this._freespinsLeft){
                    SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft);
                }
            },
            onComplete: () => {
                this.hideButtons();
                NolimitApplication.removeLayer("FreeSpinIntro");
                EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED));
                SoundPlayer.pauseAmbience();
                SoundPlayer.playAmbientLoop(WinterHoardSoundConfig.instance.FREE_SPIN_AMBIANCE, 500);
            }
        });

        tl.add(new TweenLite(this, 0.2, {alpha: 0}));
        tl.add(() => {
            this._layer.removeChild(this);
        });
        this.endTl = tl;

        return tl;
    }

    public onPickAndClickClosed(data:ParsedServerData):void {
        if(this.endTl) {
            this.endTl.progress(1);
        }
        if(GameSetting.replayMode) {
            this._bdata = data;
        }
        if(this._isWaiting) {
            if (this._bdata && (this._bdata.mode !== "FREESPIN_COMBINED" && this._bdata.nextMode !== "FREESPIN_COMBINED")) {
                this.continueButtonClicked();
                this._isSuper = false;
            }
            this._isWaiting = false;
        }
    }

    protected onResize(resizeData: IResizeData): void {
        const isLandscape: boolean = (resizeData.orientation === Orientation.LANDSCAPE);
        const buttonScale: number = 0.6;
        const buttonX: number = (isLandscape ? 250 : 192);
        this._buttons[0].scale.set(buttonScale);
        this._buttons[1].scale.set(buttonScale);
        this._buttons[0].position.x = 0 - buttonX;
        this._buttons[1].position.x = buttonX;
        this._featureTexts[0].position.set(0 - buttonX, isLandscape ? 248 : 192);
        this._featureTexts[1].position.set(buttonX, isLandscape ? 248 : 192);

        if (isLandscape) {
            this._highVLogo.position.set(-410, -15);
            this._extremeVLogo.position.set(430, -15);

            if(resizeData.width / resizeData.height <1.775){
                this._volatilityBar.scale.set(0.9);

            }
            else {
                this._volatilityBar.scale.set(1);
            }
            this._volatilityBar.y = 314;

        } else {
            this._highVLogo.position.set(-200, 40);
            this._extremeVLogo.position.set(200, 40);

            if(resizeData.height > 970) {
                this._volatilityBar.y = 365;
            }
            else {
                this._volatilityBar.y = 335;
            }

        }
        this._volatilityBar.x = 0;
        //this._volatilityBar.y = (isLandscape ? 314 : 365);

        this._dimmer.width = resizeData.width + 100;
        this._dimmer.height = resizeData.height + 100;
    }

    public prepare(data: ParsedServerData): void {
        this._numberFreespins = (<WinterHoardParsedGameData | WinterHoardParsedInitData>data).numberFreespins;
        this._freespinsLeft = data.freespinsLeft;
        this._bdata = data;
        if (GameSetting.replayMode) {
            if (data.replayNextPlayerInteraction == null) {
                debugger;
                throw new Error("PickAndClickController.onGameDataParsed() nextPlayerInteraction is missing from the server response when replay!");
            }
            this._replayPlayerSelectionIndex = data.replayNextPlayerInteraction.selectedIndex;
            if (this._replayPlayerSelectionIndex < 0) {
                debugger;
                throw new Error("PickAndClickController.onGameDataParsed() nextPlayerInteraction.selectedIndex is not a valid number!");
            }
        }
    }
}